import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Observable, of } from "rxjs";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";

@Component({
  selector: "app-collection-summary-report",
  templateUrl: "./collection-summary-report.component.html",
  styleUrls: ["./collection-summary-report.component.scss"],
})
export class CollectionSummaryReportComponent implements OnInit {
  showSpinner = false;
  DataSource: MatTableDataSource<any> = new MatTableDataSource();
  JsonData: any[] = []; // main dashboard data
  ModeData: any[] = []; // mode-level summary cards
  selectedDetailData: any[] = []; // data for modal
  selectedDetailDataSource = new MatTableDataSource<any>();
  totalCollection: any = null;

  currentUser: any;
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  startDate: string = moment(this.FromDate).format("YYYY-MM-DD");
  endDate: string = moment(this.ToDate).format("YYYY-MM-DD");
  ModeId: string = "";
  categoryConfig: any = {
    "CASH MONEY": {
      icon: "💵",
      color: "#059669",
      bgColor: "#ecfdf5",
    },
    "BANK WEB COLLECTION": {
      icon: "🏦",
      color: "#2563eb",
      bgColor: "#eff6ff",
    },
    "BANK APP COLLECTION": {
      icon: "🏦",
      color: "#2563eb",
      bgColor: "#eff6ff",
    },
    "ADJUST TO ACCOUNT": {
      icon: "🔄",
      color: "#ca8a04",
      bgColor: "#fefce8",
    },
    "OTHER COLLECTION": {
      icon: "💰",
      color: "#6b7280",
      bgColor: "#f9fafb",
    },
    "TOTAL COLLECTION": {
      icon: "💰",
      color: "#ea580c",
      bgColor: "#fff7ed",
    },
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("paginatorRef") paginator: MatPaginator;

  expandedType: string | null = null;
  currentExpandedCId: number | null = null;

  showModal = false;
  modalTitle = "";
  modalDisplayedColumns: string[] = [];

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("EMI Collection Summary Report");
    this.loadDashboardData();
  }

  // Load main dashboard
  loadDashboardData() {
    this.showSpinner = true;
    this.JsonData = [];
    this.selectedDetailData = [];
    this.reportsService
      .Collection_Summary_MAIN_DashBoard_Details({
        StartDate: this.FromDate,
        EndDate: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe({
        next: (res: any) => {
          this.JsonData = res.filter(
            (item: any) => item.Collection_Type !== "TOTAL COLLECTION"
          );
          this.totalCollection = res.find(
            (item: any) => item.Collection_Type === "TOTAL COLLECTION"
          );

          this.showSpinner = false;
        },
        error: () => {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Error loading dashboard data",
            duration: 3000,
          });
        },
      });
  }

  /** Choose correct detail API based on C_Id */
  private callDetailApiByCId(C_Id: number, payload: any): Observable<any> {
    switch (C_Id) {
      case 1:
        return this.reportsService.Collection_Summary_CASHMode(payload);
      case 2:
        return this.reportsService.Collection_Summary_Adjust_To_Account(
          payload
        );
      case 3:
        return this.reportsService.Collection_Summary_BankMode(payload);
      case 4:
        return this.reportsService.Collection_Summary_BankMode_ByApp(payload);
      case 5:
        return this.reportsService.Collection_Summary_OtherCollection(payload);
      default:
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Invalid collection type",
          duration: 3000,
        });
        return of([]);
    }
  }

  /** Expand/collapse card → load ModeId=0 data (summary) */
  toggleExpand(item: any) {
    if (this.isExpanded(item.Collection_Type)) {
      this.expandedType = null;
      this.currentExpandedCId = null;
      this.ModeData = [];
    } else {
      this.expandedType = item.Collection_Type;
      this.currentExpandedCId = item.C_Id;
      this.loadModeLevelData(item.C_Id, "");
    }
  }

  isExpanded(type: string): boolean {
    return this.expandedType === type;
  }

  /** Load mode-level summary or voucher-level data */
  loadModeLevelData(C_Id: number, modeId: string) {
    this.showSpinner = true;

    const payload = {
      StartDate: this.FromDate,
      EndDate: this.ToDate,
      LoginUserId: this.currentUser.userId,
      ModeId: modeId,
    };

    this.callDetailApiByCId(C_Id, payload).subscribe({
      next: (res: any) => {
        if (modeId === "") {
          // Summary-level (ModeId=0)
          this.ModeData = res.map((r: any) => ({
            CollectionName: r.CollectionName ?? r.Collection_Mode,
            Amount: r.Amount,
            Voucher_Count: r.Voucher_Count,
            ModeId: r.Id ?? r.ModeId ?? r.Mode_ID ?? "",
          }));
        } else {
          // Voucher-level
          this.selectedDetailData = res || [];
          this.selectedDetailDataSource = new MatTableDataSource(
            this.selectedDetailData
          );
          this.modalTitle =
            this.selectedDetailData[0]?.Collection_Mode ?? "Details";
          setTimeout(() => {
            if (this.paginator)
              this.selectedDetailDataSource.paginator = this.paginator;
          });
          this.selectedDetailDataSource.sort = this.sort;
          this.showVoucherModal();
        }
        this.showSpinner = false;
      },
      error: (err) => {
        console.error(err);
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Error loading details",
          duration: 3000,
        });
      },
    });
  }

  /** Open Mode-level details (ModeId ≠ 0) */
  openModeDetail(mode: any) {
    if (!this.currentExpandedCId) return;
    const modeId = (mode.ModeId || mode.Id || "0").toString();
    this.loadModeLevelData(this.currentExpandedCId, modeId);
  }

  /** Show voucher-level modal */
  private showVoucherModal() {
    // Set the columns to display
    this.modalDisplayedColumns = [
      "Id",
      "CaseNo",
      "Customer_Name",
      "Voucher_Date",
      "Voucher_No",
      "Voucher_Type",
      "Amount",
      "Collection_Mode",
      "Remark",
    ];

    // Force change detection and show modal
    this.showModal = true;

    // Add a small delay to ensure DOM is ready
    setTimeout(() => {
      this.showModal = true;
    }, 0);
  }

  closeModal() {
    this.showModal = false;
    this.selectedDetailData = [];
    this.modalTitle = "";
  }
  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date must be greater than From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      } else {
        // Update startDate and endDate for filtering
        this.startDate = moment(this.FromDate).format("YYYY-MM-DD");
        this.endDate = moment(this.ToDate).format("YYYY-MM-DD");
      }
    }
  }

  applyFilter(filterValue: string) {
    this.selectedDetailDataSource.filter = filterValue.trim().toLowerCase();
  }
  totaltypewise(type) {
    if (this.selectedDetailData != null) {
      let sum = 0;
      for (let i = 0; i < this.selectedDetailData.length; i++) {
        sum += Number(this.selectedDetailData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }
  calculateVoucherPercentage(modeAmount: number): string {
    if (!this.totalCollection || !this.totalCollection.Amount) {
      return "0%";
    }

    const total = Number(this.totalCollection.Amount);
    const count = Number(modeAmount);

    if (isNaN(total) || total === 0) {
      return "0%";
    }

    const percentage = (count / total) * 100;
    return `${percentage.toFixed(2)}%`;
  }

  exportTable(): void {
    const worksheetName = "Collection-Summary-Detail";
    const allData = this.selectedDetailData; // <-- full dataset

    if (!allData || allData.length === 0) {
      alert("No data available to export");
      return;
    }

    // 👇 specify columns you want to exclude
    const excludedColumns = ["Id", "CollectionName", "Voucher_Count"]; // example

    // Build headers dynamically (excluding unwanted)
    const headers = Object.keys(allData[0]).filter(
      (key) => !excludedColumns.includes(key)
    );

    let tableHTML = "<table><tr>";
    headers.forEach((header) => {
      tableHTML += `<th>${header}</th>`;
    });
    tableHTML += "</tr>";

    // Build rows
    allData.forEach((row) => {
      tableHTML += "<tr>";
      headers.forEach((header) => {
        let cellValue = row[header];
        // Escape HTML entities for safety
        if (cellValue == null) cellValue = "";
        tableHTML += `<td>${cellValue}</td>`;
      });
      tableHTML += "</tr>";
    });
    tableHTML += "</table>";

    // Excel export
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
      "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>" +
      `<x:Name>${worksheetName}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>` +
      "</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>" +
      `<body>${tableHTML}</body></html>`;

    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));

    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(template);
    downloadLink.download = worksheetName + ".xls";
    downloadLink.click();
  }
}
